<template lang="pug">
  div
    section.content-header
      h1 ユーザー管理

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active ユーザー管理

    section.content

      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          .pull-left
            app-list-sortable-nav(ref="sortableNav", :enabled="isSortable(selectGroup)")
              template(slot-scope="{toggleSortMode}")
                router-link.btn.btn-default(:to="{name: 'admin'}" title="戻る"): i.fa.fa-reply
                |
                |
                router-link.btn.btn-primary(:to="{name: 'user-add', params: {paramGruopId: selectGroup.id, paramGruopName: selectGroup.name}}" data-testid="button-add") ユーザー情報の作成
                |
                |
                .btn-separator
                |
                |
                //-（削除済み）組織を選択した時は「使用停止」と「使用再開」ボタンをロックする
                .btn-group(v-if="selectGroup.id === -4")
                  button.btn.btn-primary(@click.prevent="hasCheckedItems() ? modalDisabled = false : modalDisabledNoitem = false", :class="{'disabled': selectGroup.id === -4}") 使用停止
                  button.btn.btn-primary(@click.prevent="hasCheckedItems() ? modalEnable = false : modalEnableNoitem = false", :class="{'disabled': selectGroup.id === -4}") 使用再開
                //- その他の組織を選択した時は「使用停止」と「使用再開」ボタンをロックしない
                .btn-group(v-else)
                  button.btn.btn-primary(@click.prevent="hasCheckedItems() ? modalDisabled = true : modalDisabledNoitem = true") 使用停止
                  button.btn.btn-primary(@click.prevent="hasCheckedItems() ? modalEnable = true : modalEnableNoitem = true") 使用再開
                |
                |
                .btn-separator
                |
                |
                button.btn.btn-danger(@click.prevent="hasCheckedItems() ? modalDelete = true : modalDeleteNoitem = true") 削除
                |
                |
                .btn-separator
                |
                |
                .btn-group
                  div(class=attributes.class)
                    a.btn.btn-default.dropdown-toggle(href='#', data-toggle='dropdown', aria-expanded='false')
                      | その他の機能
                      |
                      span.caret
                    ul.dropdown-menu
                      li(v-if="isSortable(selectGroup)")
                        a(href="#", @click.prevent="toggleSortMode") 表示順変更
                      li(v-if="isSortable(selectGroup)").divider
                      li: router-link(:to="{name: 'user-import'}") ユーザー情報のインポート
                      li: router-link(:to="{name: 'user-export'}") ユーザー情報のエクスポート
          .pull-right
            app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      +btnbar

      .row.bcard-table-with-menu
        .col-md-3.bcard-table-menu-container
          .panel.panel-default(v-show="!tree_init")
            loading
          .panel.panel-default#bcard-group-tree(v-show="tree_init", data-testid="group-tree-panel")
            .panel-heading
              h5 所属組織
            .panel-body
              ul.bcard-tree.bcard-side-tree
                li.list-group-item.fixed
                  .bcard-group-tree-item
                    .bcard-group-tree-select-area(:class="[selectGroup.id === 0 ? 'selected' : '']")
                      a(href="#", @click.prevent="setGroupId(0)", data-testid="-link-all")
                        | (すべてのユーザー)

                group-tree-item(
                  :onClickName="setGroupId",
                  :selectedIds="[selectGroup.id > 0 ? selectGroup.id : 0]",
                  :showRoot="false",
                  @complete-initializing="showTree"
                )

                li.list-group-item.fixed
                  .bcard-group-tree-item
                    .bcard-group-tree-select-area(:class="[selectGroup.id === -1 ? 'selected' : '']")
                      a(href="#", @click.prevent="setGroupId(-1)")
                        | (組織に属さない)

                li.list-group-item.fixed
                  .bcard-group-tree-item
                    .bcard-group-tree-select-area(:class="[selectGroup.id === -2 ? 'selected' : '']")
                      a(href="#", @click.prevent="setGroupId(-2)")
                        | (使用停止中)

                li.list-group-item.fixed
                  .bcard-group-tree-item
                    .bcard-group-tree-select-area(:class="[selectGroup.id === -3 ? 'selected' : '']")
                      a(href="#", @click.prevent="setGroupId(-3)")
                        | (ログイン拒否中)

                li.list-group-item.fixed
                  .bcard-group-tree-item
                    .bcard-group-tree-select-area(:class="[selectGroup.id === -4 ? 'selected' : '']")
                      a(href="#", @click.prevent="setGroupId(-4)")
                        | (削除済み)

            //- 表示順変更モードの場合、マスクをかける
            .sort-mode-overlay(v-if="$store.getState('isListSortMode')")

        .col-md-9.bcard-table-list-container
          .panel.panel-default(data-testid="user-list-panel")
            .panel-heading
              //- 検索
              form(action="#", @submit.prevent="getList({page: {page: 1}})")
                .input-group
                  input.form-control(type="text" name="keyword" placeholder="氏名、所属組織、役職、メールアドレスで検索", data-testid="input-search", v-model="keyword")
                  span.input-group-btn
                    button.btn.btn-info(type="submit" title="検索", data-testid="-btn-user-search")
                      i.fa.fa-search

            loading(v-if="loading && tree_height !== 0", :height="tree_height")
            loading(v-else-if="loading")

            //- データあり
            .table-responsive.bcard-table-container(v-else-if="list.length > 0")
              table.table.table-striped.table-bordered.bcard-table(:class="{'sort-mode': $store.getState('isListSortMode')}")
                thead
                  tr
                    th.bcard-table-td-chk
                      input(type="checkbox" @change="checkAll(list, $event.target.checked)" :disabled="$store.getState('isListSortMode')")
                    th.bcard-table-td-fullname 氏名
                    th.bcard-table-td-groups 所属組織
                    th.bcard-table-td-post 役職
                    th.bcard-table-td-email メールアドレス
                app-list-sortable(ref="sortableList", v-model="list", repo="user", :params="sortParams", :enabled="isSortable(selectGroup)")
                  tr(
                      v-for="(item, index) in list",
                      :key="item.id",
                      :class="{'selected': isChecked(item.id)}",
                      :data-testid="item.last_name + ' ' + item.first_name"
                    )
                    td.bcard-table-td-chk
                      input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)", :disabled="$store.getState('isListSortMode')")
                    td.bcard-ui-userdata
                      template(v-if="item.user_state === '1'"): i.fa.bcard-fa-user-times.fa-fw
                      template(v-else-if="item.user_state === '3'"): i.fa.bcard-fa-user-minus.fa-fw
                      |
                      |
                      router-link(v-if="!$store.getState('isListSortMode')", :to="{name: 'user-edit', params: {id: '' + item.id, item: item, paramGruopId: selectGroup.id, paramGruopName: selectGroup.name}}", :title="item.last_name + ' ' + item.first_name") {{item.last_name + ' ' + item.first_name}}
                      router-link(v-else :to="{}", :title="item.last_name + ' ' + item.first_name" event="") {{item.last_name + ' ' + item.first_name}}
                    td.bcard-ui-userdata
                      span(:title="getGroupNames(item.group_users)")
                        template(v-for="(groupuser, index) in item.group_users")
                          template(v-if="index !== 0") ,&nbsp;
                          span(:class="{'bcard-usergroup-def': item.defgroup ===  groupuser.id}") {{groupuser.group.name}}
                    td.bcard-ui-userdata
                      span(:title="item.post") {{item.post}}
                    td.bcard-ui-userdata
                      a(v-if="!$store.getState('isListSortMode')", :href="'mailto:' + item.mail", :title="item.mail") {{item.mail}}
                      router-link(v-else :to="{}", :title="item.mail" event="") {{item.mail}}

            //- データなし
            .panel-body.text-center(v-else) ユーザー情報はありません。

      +btnbar(class="dropup")

      //- 凡例
      ul.bcard-legend
        li
          span: i.fa.bcard-fa-user-minus.fa-fw
          | ：使用停止中のユーザー
        li
          span: i.fa.bcard-fa-user-times.fa-fw
          | ：削除済みのユーザー

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="modalDelete" type="danger")
      template(slot="title") ユーザー情報の削除
      h4 選択したユーザーを削除します。よろしいですか？
      .help-block
        p.bcard-comments.text-danger
          | ※ 選択したユーザーが「削除済みのユーザー」の場合、データベースから対象のユーザー情報が削除され、そのユーザーに紐づく検索キーワードや個人メモなどのユーザーデータも削除されます。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="delUsers") 削除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalDeleteNoitem" type="info")
      h4 削除するユーザーを選択してください。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-default(@click="close") 閉じる

    app-modal(v-model="modalDisabled" type="primary")
      template(slot="title") ユーザー情報の使用停止
      h4 選択したユーザーを使用停止にします。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(@click="disabledUsers") 使用停止
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalDisabledNoitem" type="info")
      h4 使用停止にするユーザーを選択してください。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-default(@click="close") 閉じる

    app-modal(v-model="modalEnable" type="primary")
      template(slot="title") ユーザー情報の使用再開
      h4 選択したユーザーを使用再開にします。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(@click="enableUsers") 使用再開
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalEnableNoitem" type="info")
      h4 使用再開にするユーザーを選択してください。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-default(@click="close") 閉じる

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppListSortable from '@/components/organisms/AppListSortable'
import AppListSortableNav from '@/components/organisms/AppListSortableNav'
import GroupTreeItem from '@/components/organisms/GroupTreeItem'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'UserList',
  components: { AppModal, AppMessages, AppPagination, AppListSortable, AppListSortableNav, GroupTreeItem, Loading },
  mixins: [ mixinList ],
  props: {
    // 追加・変更画面から渡される初期表示の所属組織
    paramGruopId: {type: Number, required: false, default: 0},
    paramGruopName: {type: String, required: false, default: ''}
  },
  data () {
    return {
      loadingPagination: true,
      loading: true,
      selectGroup: {
        id: 0,
        name: ''
      },
      keyword: '',

      // 各モーダルフラグ
      modalDelete: false,
      modalDeleteNoitem: false,
      modalDisabled: false,
      modalDisabledNoitem: false,
      modalEnable: false,
      modalEnableNoitem: false,
      // 組織ツリーの高さ
      tree_height: 0,
      tree_init: false
    }
  },
  // ソート対象の組織IDを返す
  computed: {
    sortParams () {
      return [
        {group_id: this.selectGroup.id}
      ]
    }
  },
  created () {
    // 追加・変更画面から渡された所属組織を取得
    this.selectGroup.id = this.paramGruopId
    this.selectGroup.name = this.paramGruopName

    // サイドメニューから遷移した場合
    if (this.$route.params.init) {
      this.getList({page: 1})
    }
    else {
      // 初期データ取得
      this.getList({page: this.pagination.current_page || 1})
    }
  },
  methods: {
    /**
     * 所属タイトル名取得処理
     * @param array group_users: 所属オブジェクト配列
     */
    getGroupNames (group_users) {
      let gnames = ''
      for (let i = 0, l = group_users.length; i < l; i++) {
        if (i !== 0) {
          gnames += ', '
        }
        gnames += group_users[i].group.name
      }
      return gnames
    },
    /**
     * ユーザー削除処理
     */
    delUsers () {
      const vm = this

      // パラメータの整形
      let states = []
      for (let key in this.checkedIds) {
        let checkedUser = {}
        // IE11 find() 未実装
        // let checkedUser = this.list.find(function (item) {
        //   return (item.id === vm.checkedIds[key])
        // })

        // find() 互換処理
        for (let item of this.list) {
          if (item.id === vm.checkedIds[key]) {
            checkedUser = item
            break
          }
        }

        states.push(checkedUser.user_state)
      }

      // API実行
      this.clearErrorMessages()
      this.sendBulkRequest('user', 'bulkDelete', {
        params: {
          id: this.checkedIds,
          state: states
        }
      })
      if (this.modalDelete) {
        this.modalDelete = false
      }
    },
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList (options) {
      const vm = this
      options = options || {}
      this.loading = true
      this.loadingPagination = !options.viaPagination
      // API実行
      this.sendListRequest({
        repo: 'user',
        method: 'getList',
        params: {
          page: options.page || 1,
          group: this.selectGroup.id,
          keyword: this.keyword
        },
        finally () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    },
    // ------------------------------------------------------------
    // 使用停止・再開
    // ------------------------------------------------------------
    disabledUsers () {
      // API実行
      this.clearErrorMessages()
      this.sendBulkRequest('user', 'changeStatus', {
        params: {
          id: this.checkedIds,
          state: '3'
        }
      })
      if (this.modalDisabled) {
        this.modalDisabled = false
      }
    },
    enableUsers () {
      // API実行
      this.clearErrorMessages()
      this.sendBulkRequest('user', 'changeStatus', {
        params: {
          id: this.checkedIds,
          state: '0'
        }
      })
      if (this.modalEnable) {
        this.modalEnable = false
      }
    },
    // ツリーコンポーネントに渡して実行させる
    // 所属組織IDを更新
    setGroupId (group) {
      // ロード中の一覧の高さをツリーに合わせる
      this.setTreeHeight()

      if (typeof group === 'object') {
        this.selectGroup.id = group.id
        this.selectGroup.name = group.name
      }
      else {
        this.selectGroup.id = group
        this.selectGroup.name = ''
      }
      this.resetKeyword()
      this.getList({page: 1})
    },
    resetKeyword () {
      this.keyword = ''
    },
    isSortable (selectGroup) {
      return selectGroup.id >= 0
    },
    // 組織ツリーの高さを取得
    setTreeHeight () {
      this.tree_height = document.getElementById('bcard-group-tree').clientHeight
    },
    showTree () {
      this.tree_init = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/user/List.vue